<template>
    <div class="wrapper p-b-10-mobile">
        <div class="columns">
            <div class="column">
                <back-button />
            </div>
        </div>
        <div class="columns is-vcentered ">
            <div v-if="$route.params.id && $route.params.id == 'max-5'" class="column is-1"></div>
            <div class="column is-2">
                <div class="banner-home is-hidden-mobile">
                    <div class="banner-on-top">
                        <AdsGoogle slot="6672232476"/>
                    </div>
                </div>
            </div>
            <div v-if="$route.params.id && $route.params.id == 'max-5'" class="column is-6" style="min-width:fit-content">
              <div class="columns is-justify-content-center">
               <div style="min-width: fit-content;">
                <div class="columns is-justify-content-center mb-0">
                    <div class="column is-hidden-mobile">
                        <div class="is-size-5 has-text-centered is-flex is-align-items-center is-justify-content-center m-b-10">To use this feature,</div>
                        <div class="m-l-20 is-size-5 has-text-centered is-flex is-align-items-center is-justify-content-center is-white-space-nowrap">please 
                            <a class="button is-primary mx-1" @click="goToLoginNotHistory">log in</a>&nbsp;|&nbsp;
                            <a class="button is-primary mx-1" @click="$router.push('/register')">sign up</a><strong> for FREE</strong>!
                        </div>
                        <div class="is-size-5 has-text-centered is-flex is-align-items-center is-justify-content-center is-white-space-nowrap m-t-20 m-r-10">Or</div>
                        <div class="is-size-5 has-text-centered m-r-10 is-flex is-align-items-center is-justify-content-center m-t-20 is-white-space-nowrap">
                            <a class="button is-primary mx-1" @click="$store.commit('search/SET_BACKBTN_RESULTS', true),$router.back()">Continue as a visitor</a>
                        </div>
                    </div>

                    <div class="column is-12 is-hidden-tablet px-2 text-align-center">
                        <div class="m-b-10">To use this feature,</div>
                        <p class="font-large text-line"><span class="line-height-medium">please <a class="text-blue-a is-size-7 has-text-weight-bold" @click="goToLoginNotHistory">login</a>&nbsp;|&nbsp;<a class="text-blue-a is-size-7 has-text-weight-bold" @click="$router.push('/register')">sign up</a></span><strong> for FREE</strong>!</p>
                        <p class="font-large text-line m-t-20 m-r-25">Or</p>
                        <div class="is-size-5 has-text-centered is-flex is-align-items-center is-justify-content-center m-t-20 is-white-space-nowrap m-r-20">
                            <a class="button is-primary mx-1 is-size-7" @click="$store.commit('search/SET_BACKBTN_RESULTS', true),$router.back()">Continue as a visitor</a>
                        </div>
                    </div>
                </div>

                <div class="mt-3 mb-4 is-justify-content-center">
                    <div class="has-text-centered is-align-items-center m-b-10">
                        <span class="has-text-weight-bold">Signed up</span> users will have
                    </div>
                    <div class="has-text-centered is-align-items-center has-text-underline m-b-10">
                        full unrestricted access to the pickafund capabilities 
                    </div>
                    <div class="has-text-centered is-align-items-center m-b-10">
                        See table below
                    </div>
                </div>
                
                <div class="columns is-justify-content-center" style="padding: 0.75rem;">
                    <div class="rule-login column is-12 mb-4 p-l-0 p-r-0 p-r-20-mobile p-l-20-mobile">
                    <table>
                    <tr class="background-header">
                        <th style="width: 50%;">Access To</th>
                        <th style="width: 25%;">Visitor</th> 
                        <th style="width: 25%;">Signed Up</th>
                    </tr>
                    <tr>
                        <td>Search</td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit.includes('sorting-option') ? 'highlight-row': ''">
                        <td>Sorting Options</td>
                        <td class="color-red has-text-weight-bold">Standard</td>
                        <td class="color-green has-text-weight-bold">All</td>
                    </tr>
                    <tr>
                        <td>Basic Filters</td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit==='advanced-filter' ? 'highlight-row': ''">
                        <td>Advanced Filters</td>
                        <td><b-icon class="red is-size-5-tablet pt-1" icon="close" size="is-small"></b-icon></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    <tr>
                        <td>Detailed View Page</td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit==='comparison' ? 'highlight-row': ''">
                        <td>Comparison To Peers Page</td>
                        <td class="color-red has-text-weight-bold">Up to 5</td>
                        <td class="color-green has-text-weight-bold">Unlimited</td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit==='referral' ? 'highlight-row': ''">
                        <td>Investment Platforms Page</td>
                        <td class="color-red has-text-weight-bold">Up to 5</td>
                        <td class="color-green has-text-weight-bold">Unlimited</td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit==='dashboard' ? 'highlight-row': ''">
                        <td>Dashboard</td>
                        <td><b-icon class="red is-size-5-tablet pt-1" icon="close" size="is-small"></b-icon></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit==='watchlist' ? 'highlight-row': ''">
                        <td>Watchlists</td>
                        <td><b-icon class="red is-size-5-tablet pt-1" icon="close" size="is-small"></b-icon></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit==='alert' ? 'highlight-row': ''">
                        <td>Alerts</td>
                        <td><b-icon class="red is-size-5-tablet pt-1" icon="close" size="is-small"></b-icon></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    <tr :class="$store.state.auth.hittingLimit==='alert' ? 'highlight-row': ''">
                        <td>Choose categories on "Vs" pages</td>
                        <td><b-icon class="red is-size-5-tablet pt-1" icon="close" size="is-small"></b-icon></td>
                        <td><img class="no-yes-custom" src="/img/tick.svg"></td>
                    </tr>
                    </table>
                    </div>
                </div>
               </div>
              </div>
            </div>
            <div v-else class="column is-8">
                <div class="columns is-tablet sign-up">
                    <div class="column is-6-tablet">
                        <h1 class="is-size-4 has-text-weight-bold m-b-40 m-b-15-mobile is-hidden-mobile">
                            <span class="font-weight-400">Not registered?</span> <br>Sign Up for free!</h1>
                        <h1 class="is-size-5 has-text-weight-bold m-b-40 m-b-15-mobile is-hidden-tablet"><span class="font-weight-400">Not registered?</span> <br>Sign Up for free!</h1>
                        <router-link to="/register" class="button is-primary">SIGN UP</router-link> 
                        <h2 class="is-size-5 has-text-weight-bold m-t-50 m-b-50 m-t-30-mobile m-b-30-mobile">Why you’ll love pickafund.com</h2>
                        <ul class="logo-list">
                            <li>Search ALL funds available to UK retail investors</li>
                            <li>Compare funds to their peers for valuable insight</li>
                            <li>Find the best platform for your investment</li>
                            <li>Set up watchlists and alerts</li>
                        </ul>
                    </div>

                    <hr class="hr-gray is-hidden-tablet my-4">

                    <div class="column is-6-tablet login-form-wrapper">
                        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
                            <h1 class="is-size-4 has-text-weight-bold m-b-40 m-b-15-mobile">
                                <span class="font-weight-400 is-hidden-mobile" style="opacity: 0;">Not registered?</span> 
                                <br class="is-hidden-mobile">
                                Log in
                            </h1>
                            <div class="columns m-b-0-mobile">
                                <div class="column is-12 is-12-tablet">
                                    <ValidationProvider rules="required|email|min:8" v-slot="{ errors,valid }">
                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                        :message="errors">
                                        <b-input v-model="form.email" placeholder="Email"
                                                size="is-medium"
                                                icon="account"
                                                type="email"
                                                novalidate
                                                autocapitalize="off">
                                        </b-input>

                                    </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns m-b-0-mobile">
                                <div class="column is-12 p-b-0-mobile">
                                    <ValidationProvider rules="required|min:8" v-slot="{ errors,valid }">
                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                        :message="errors">
                                        <b-input v-model="form.password" placeholder="Password"
                                                type="password"
                                                size="is-medium"
                                                icon="account"
                                                password-reveal>
                                        </b-input>
                                    </b-field>
                                    </ValidationProvider>
                                    <p class="has-text-right">
                                        <router-link class="has-text-underline" to="/lostpassword">Forgot password</router-link>
                                    </p>
                                </div>
                            </div>
                            <b-button @click="submit" type="is-primary">LOG IN</b-button>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="banner-home is-hidden-mobile">
                    <div class="banner-on-top">
                        <AdsGoogle/>
                    </div>
                </div>
            </div>
            <div v-if="$route.params.id && $route.params.id == 'max-5'" class="column is-1"></div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
import axios from "axios"
import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
import BackButton from "@/components/BackButton";
import AdsGoogle from '@/components/AdsGoogle.vue';
setInteractionMode('eager')


export default {
    name: 'SignUp1',
    props: {
        to:Object
    },
    components: {
        BackButton,
        ValidationProvider,
        ValidationObserver,
        AdsGoogle
    },
    data() {
        return {
            form: {
                email: "",
                password: "",
            },
            isRestriction: false,
        }
    },
    methods: {
        async submit() {
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    //const el = document.querySelector(".v-messages.error--text:first-of-type");
                    //el.scrollIntoView(true);
                    //window.scrollBy(0, -150);
                    return;
                }
                await axios.get('/sanctum/csrf-cookie')
                await axios.post("/api/login", this.form).then(response => {
                    if(response.data.status == "ok"){
                        this.$store.commit("auth/SET_AUTHENTICATED", true)
                        localStorage.removeItem('comparecount');
                        localStorage.removeItem('comparecount2');
                        this.$toast.success("You have been logged in successfully")
                    axios.get("/api/profile").then(async response => {
                        const profile = response.data
                        this.$store.commit("auth/SET_USER_PROFILE", profile);
                        if(profile.completedstage2 === true){
                          this.$store.commit("auth/SET_PROFILE",2)
                        }
                        else if(profile.completedstage1=== true){
                          this.$store.commit("auth/SET_PROFILE",1)
                        }
                        if(profile.email) {
                            this.$store.commit("auth/SET_EMAIL", profile.email)
                        }
                        if(profile.age) {
                            this.checkRestriction()
                        }
                        else {
                            this.$router.push("/account")
                        }
                      }).catch(() => this.$router.push("/account"))

                    }
                    else{
                        this.$toast.error(response.data.error)
                        
                    }

                })
                    .catch(() => {
                        this.$toast.error("We cannot find your credentials")
                    })
            })
        },
        goToLoginNotHistory(e) {
            e.preventDefault();
            this.isRestriction=true;
            this.$router.push("/login")
        },
        checkRestriction() {
            if (this.$store.state.auth.previousPage) {
                return this.$router.push(this.$store.state.auth.previousPage)
            } else {
                if (this.$store.state.vsPage.previousPage) {
                    this.$router.push(this.$store.state.vsPage.previousPage);
                }
                else {
                    this.$router.push("/")
                }
            }
        }
    },
    watch: {
        '$store.state.auth.authenticated': function (data) {
            if(data && !this.form.email) this.$router.push('/')
        },
        '$route'(to, from) {
            if(((from.path === '/login' && to.path === '/login/max-5') || (to.path && to.path.includes('/login'))) && this.$store.state.auth.authenticated) this.$router.push('/');
        }
    },
}
</script>


